import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CadastrarEstudanteLayer from "../components/CadastrarEstudanteLayer";
import { useTranslation } from "../i18n/I18nContext";

const CadastrarEstudantePage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("estudante.breadcrumb.create")} />
      <CadastrarEstudanteLayer />
    </MasterLayout>
  );
};

export default CadastrarEstudantePage;
